'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64 from "./presto.types$proto$-Unsigned-File-Base64.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UnsignedFileBase64$() {
}
export { $c_Lpresto_types$proto$UnsignedFileBase64$ as $c_Lpresto_types$proto$UnsignedFileBase64$ };
$p = $c_Lpresto_types$proto$UnsignedFileBase64$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UnsignedFileBase64$;
/** @constructor */
function $h_Lpresto_types$proto$UnsignedFileBase64$() {
}
export { $h_Lpresto_types$proto$UnsignedFileBase64$ as $h_Lpresto_types$proto$UnsignedFileBase64$ };
$h_Lpresto_types$proto$UnsignedFileBase64$.prototype = $p;
$p.l = (function() {
  return "UnsignedFileBase64";
});
$p.cH9 = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64.$c_Lpresto_types$proto$UnsignedFileBase64(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$proto$UnsignedFileBase64$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UnsignedFileBase64$, "presto.types$proto$UnsignedFileBase64$", ({
  a3I: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$UnsignedFileBase64$ as $d_Lpresto_types$proto$UnsignedFileBase64$ };
var $n_Lpresto_types$proto$UnsignedFileBase64$;
function $m_Lpresto_types$proto$UnsignedFileBase64$() {
  if ((!$n_Lpresto_types$proto$UnsignedFileBase64$)) {
    $n_Lpresto_types$proto$UnsignedFileBase64$ = new $c_Lpresto_types$proto$UnsignedFileBase64$();
  }
  return $n_Lpresto_types$proto$UnsignedFileBase64$;
}
export { $m_Lpresto_types$proto$UnsignedFileBase64$ as $m_Lpresto_types$proto$UnsignedFileBase64$ };
//# sourceMappingURL=presto.types$proto$-Unsigned-File-Base64$.js.map
